import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=74634dfc&scoped=true&"
import script from "./FileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./FileThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=74634dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74634dfc",
  null
  
)

export default component.exports